/**
 * CategoryLayout Factory
 */
(function () {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxCategoryLayoutSvc', ItxCategoryLayoutSvc);

    ItxCategoryLayoutSvc.$inject = ['ItxConstants', 'ItxScreenSizeSvc', '$timeout', 'imCategoryFilter'];

    /**
     * Control Category page layout classes and implement utility functions for interaction
     * @constructor
     */
    function ItxCategoryLayoutSvc(ItxConstants, ItxScreenSizeSvc, $timeout, imCategoryFilter) {
        var isExpanded = JSON.parse( inditex.getLocalStorage( ItxConstants.layoutExpandedKey ) ) || false;

        return {
            /**
             * Check if using the layout expanded mode
             * @returns {boolean}
             */
            isExpanded: function () {
                return isExpanded;
            },

            /**
             * Set collapsed mode
             */
            setCollapsed: function () {
                var imState = isExpanded;
                inditex.setLocalStorage( ItxConstants.layoutExpandedKey, false );
                isExpanded = false;
                imCategoryFilter.changeView(imState);
            },

            /**
             * Set expanded mode
             */
            setExpanded: function () {
                var imState = isExpanded;
                inditex.setLocalStorage( ItxConstants.layoutExpandedKey, true );
                isExpanded = true;
                imCategoryFilter.changeView(imState);
            },

            
            /**
             * Indicates if the product is showing double
             * @param {object} product - The product to layout
             * @returns {*}
             */
            showingDouble: function(product) {
                if (this.isExpanded()) {
                    if (product.config && product.config.isDoubleBox) {
                        if (ItxScreenSizeSvc.is('xs')) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    if (product.config && product.config.isDoubleBox) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        };
    }



})();
